export default __webpack_public_path__ + "static/media/1.32d4ba28.jpg";